import React from 'react'
import { ReviewItems } from '../ReviewItems'
import {
  formatAddress,
  formatPersonName,
  formatReviewString
} from '../../utilities'
import {
  addressLabel,
  cellPhoneLabel,
  employerLabel,
  employerPhoneLabel,
  homePhoneLabel,
  jobTitleLabel,
  homeAddressLabel,
  nameLabel,
  personalEmailLabel,
  workEmailLabel,
  workPhoneLabel
} from '../../strings/labels'

export const ReviewParentGuardian = ({
  address,
  address2,
  city,
  state,
  zip,
  country,
  first_name,
  middle_name,
  last_name,
  suffix,
  email,
  employment,
  phone,
  phone2,
  victims,
  editFieldName,
  onClick
}) => {
  let formattedPersonName = formatReviewString(
    formatPersonName(first_name, middle_name, last_name, suffix)
  )
  formattedPersonName =
    formattedPersonName === '-' ? 'None provided' : formattedPersonName

  const formattedVictims = victims
    .map(v =>
      formatPersonName(v.first_name, v.middle_name, v.last_name, v.suffix)
    )
    .join(', ')

  let personal_details = [
    {
      heading: nameLabel,
      value: formattedPersonName
    },
    {
      heading: 'Victims',
      value: formatReviewString(formattedVictims)
    }
  ]

  let contact_details = [
    {
      heading: homePhoneLabel,
      value: formatReviewString(phone2)
    },
    {
      heading: cellPhoneLabel,
      value: formatReviewString(phone)
    },
    {
      heading: workPhoneLabel,
      value: formatReviewString(employment.phone2)
    },
    {
      heading: personalEmailLabel,
      value: formatReviewString(email)
    },
    {
      heading: workEmailLabel,
      value: formatReviewString(employment.email)
    },
    {
      heading: homeAddressLabel,
      value: formatReviewString(
        formatAddress({
          line1Value: address,
          line2Value: address2,
          cityValue: city,
          stateValue: state,
          zipValue: zip,
          countryValue: country
        })
      )
    }
  ]

  let employer_details = [
    {
      heading: jobTitleLabel,
      value: formatReviewString(employment.job_title)
    },
    {
      heading: employerLabel,
      value: formatReviewString(employment.employer)
    },
    {
      heading: addressLabel,
      value: formatReviewString(
        formatAddress({
          line1Value: employment.address,
          line2Value: employment.address2,
          cityValue: employment.city,
          stateValue: employment.state,
          zipValue: employment.zip,
          countryValue: employment.country
        })
      )
    },
    {
      heading: employerPhoneLabel,
      value: formatReviewString(employment.phone)
    }
  ]

  const addCommonProps = items =>
    items.map(item => {
      return {
        ...item,
        field_name: editFieldName,
        onClick
      }
    })

  personal_details = addCommonProps(personal_details)
  contact_details = addCommonProps(contact_details)
  employer_details = addCommonProps(employer_details)

  return (
    <React.Fragment>
      <ReviewItems items={personal_details} />
      <h3>Contact details</h3>
      <ReviewItems items={contact_details} />
      <h3>Employment information</h3>
      <ReviewItems items={employer_details} />
    </React.Fragment>
  )
}
